/* eslint-disable */
import request from './helpers'

export function login (data) {
  return request({
    url: '/api/v1/auth/login',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getToken (token) {
  return request({
    url: '/api/v1/auth/loginByToken',
    method: 'get',
    params: {
      token
    }
  })
}

export function getUserList (size, page) {
  return request ({
    url: '/api/v1/user',
    method: 'get',
    params: {
      size,
      page
    }
  })
}

export function getAllUser () {
  return request ({
    url: '/api/v1/user/all',
    method: 'get'
  })
}

export function deleteUser (id) {
  return request ({
    url: '/api/v1/user/' + id,
    method: 'delete'
  })
}

export function getUserAssociation (id) {
  return request ({
    url: '/api/v1/user/' + id + '/association',
    method: 'get'
  })
}

export function updateUser (id, data) {
  return request ({
    url: '/api/v1/user/' + id,
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function createUser (data) {
  return request ({
    url: '/api/v1/user',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function getUserListByName (name, size, page) {
  return request ({
    url: '/api/v1/user/search/' + name,
    method: 'get',
    params: {
      name,
      // pageable:{
        size,
        page
      // }
    }
  })
}

export function resetUserSecret (id, resetType) {
  return request ({
    url: '/api/v1/user/' + id + '/secret',
    method: 'get',
    params: {
      resetType
    }
  })
}

export function activeUser (id, active) {
  return request ({
    url: '/api/v1/user/' + id + '/status',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      id,
      active
    }
  })
}

export function getUserListById (id) {
  return request ({
    url: '/api/v1/user/' + id,
    method: 'get'
  })
}

// Topic
export function getTopicList (size, page) {
  return request ({
    url: '/api/v1/topic',
    method: 'get',
    params: {
      size,
      page
    }
  })
}

export function getInternalTopicList () {
  return request ({
    url: '/api/v1/topic/internal',
    method: 'get'
  })
}

export function cleanInternalTopic () {
  return request ({
    url: '/api/v1/topic/internal/clean',
    method: 'post'
  })
}

export function updateOldTopicsRetention () {
  return request ({
    url: '/api/v1/topic/update/retention_day',
    method: 'post'
  })
}

export function updateOldTopicsProducerClientParam () {
  return request ({
    url: '/api/v1/topic/update/producer_client_param',
    method: 'post'
  })
}

export function updateTopicForOldSubscribers (data) {
  return request ({
    url: '/api/v1/topic/update/old/topic_subscriber_map',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    params: data
  })
}

export function updateTopicsMinInSyncReplica (data) {
  return request ({
    url: '/api/v1/topic/update/min_in_sync_replica',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function updateOldTopicsFailedRate (data) {
  return request ({
    url: '/api/v1/topic/update/failedrate',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function migrateTopic (data) {
  return request ({
    url: '/api/v1/topic/migrate',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function getTopicConfig () {
  return request ({
    url: '/api/v1/topic/check',
    method: 'get',
  })
}

export function createTopic (data) {
  return request ({
    url: '/api/v1/topic',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function batchCreateTopic (data) {
  return request ({
    url: '/api/v1/topic/batch/create',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function duplicateTopic (id, data) {
  return request ({
    url: '/api/v1/topic/' + id,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function getTopicListByNamelike (name, size, page) {
  return request ({
    url: '/api/v1/topic/search/' + name,
    method: 'get',
    params: {
      name,
      size,
      page
    }
  })
}

export function getTopicListBySubscribersCount (subscribersCount, size, page) {
  return request ({
    url: '/api/v1/topic/lists/' + subscribersCount,
    method: 'get',
    params: {
      subscribersCount,
      size,
      page
    }
  })
}

export function updateTopic (id, data) {
  return request ({
    url: '/api/v1/topic/' + id,
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function updateProducerSetting (data) {
  return request ({
    url: '/api/v1/topic/producer/setting',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function activeTopic (id, active) {
  return request ({
    url: '/api/v1/topic/' + id + '/status',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      id,
      active
    }
  })
}

export function deleteTopic (id) {
  return request ({
    url: '/api/v1/topic/' + id,
    method: 'delete'
  })
}

export function getTopicById (id) {
  return request ({
    url: '/api/v1/topic/' + id,
    method: 'get'
  })
}

export function getTopicByChannel (id) {
  return request ({
    url: '/api/v1/topic/' + id + '/show',
    method: 'get'
  })
}

export function getTopicPrivileges (id) {
  return request ({
    url: '/api/v1/topic/' + id + '/privileges',
    method: 'get',
  })
}

export function updateTopicPrivileges (id, data) {
  return request ({
    url: '/api/v1/topic/' + id + '/privileges',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function batchUpdateTopicPrivileges (data) {
  return request ({
    url: '/api/v1/topic/batch/change/privileges',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function batchDelete (data) {
  return request ({
    url: '/api/v1/topic/batch/delete',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function getTopicRemain (id, queryRemain) {
  return request ({
    url: '/api/v1/topic/' + id + '/remain',
    method: 'get',
    params: {
      queryRemain
    }
  })
}

export function getTopicSubscriber (id, group, size, page, status, haStatus) {
  return request ({
    url: '/api/v1/topic/list/' + id + '/' + group + '/subscribers',
    method: 'get',
    params: {
      size, page, status, haStatus
    }
  })
}

export function getTopicPublisher (id, size, page, status, haStatus) {
  return request ({
    url: '/api/v1/topic/list/' + id + '/producers',
    method: 'get',
    params: {
      size, page, status, haStatus
    }
  })
}

export function updateSubscriber (data) {
  return request ({
    url: '/api/v1/topic/subscriber/setting',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function deleteSubscriber (id, group) {
  return request ({
    url: '/api/v1/topic/' + id + '/' + group + '/subscriber',
    method: 'delete'
  })
}

export function updateProducer (data) {
  return request ({
    url: '/api/v1/topic/producer/setting',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function refreshProducer (id, clientId, topicId, userId) {
  return request ({
    url: '/api/v1/topic/producer/detail',
    method: 'get',
    params: {
      id, clientId, topicId, userId
    }
  })
}

export function refreshSubscriber (id, clientId, topicId, group, userId) {
  return request ({
    url: '/api/v1/topic/subscriber/detail',
    method: 'get',
    params: {
      id, clientId, topicId, group, userId
    }
  })
}

// Task
export function createTask (data) {
  return request ({
    url: '/api/v1/task',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function getTaskList (name, keyword, minConsumeCost, maxConsumeCost, group, topicId, taskType, from, to, status, size, page) {
  return request ({
    url: '/api/v1/task/now',
    method: 'get',
    params: {
      name,
      keyword,
      minConsumeCost,
      maxConsumeCost,
      group,
      topicId,
      taskType,
      from,
      to,
      status,
        size,
        page
    }
  })
}

export function deleteTaskList (name, group, minConsumeCost, maxConsumeCost, topicId, taskType, from, to, status, size, page) {
  return request ({
    url: '/api/v1/task/now',
    method: 'delete',
    params: {
      name,
      group,
      minConsumeCost,
      maxConsumeCost,
      topicId,
      taskType,
      from,
      to,
      status,
      size,
      page
    }
  })
}

export function deleteTask (id, status) {
  return request ({
    url: '/api/v1/task/' + id + '?status=' + status,
    method: 'delete',
    data: {
      'status': status
    }
  })
}

export function getTaskListByNamelike (name, type, size, page) {
  return request ({
    url: '/api/v1/task/name/' + name,
    method: 'get',
    params: {
      name,
      type,
      size,
      page
    }
  })
}

export function getTaskListById (id) {
  return request ({
    url: '/api/v1/task/' + id,
    method: 'get'
  })
}

export function getTopicTasksByOriginalTaskId (id, size, page) {
  return request ({
    url: '/api/v1/task/original/' + id,
    method: 'get',
    params: {
      size,
      page
    }
  })
}

export function getTaskListByParentId (parentId, size, page) {
  return request ({
    url: '/api/v1/task/parent/' + parentId,
    method: 'get',
    params: {
      parentId,
      size,
      page
    }
  })
}

export function getTaskListByKeyword (keyword, size, page) {
  return request ({
    url: '/api/v1/task/keyword/' + keyword,
    method: 'get',
    params: {
      keyword,
      size,
      page
    }
  })
}

export function triggerTopicTask (id, status) {
  return request ({
    url: '/api/v1/task/' + id + '/trigger',
    method: 'put',
    params: {
      status
    }
  })
}

export function uploadSSL (data) {
  return request ({
    url: '/api/v1/cluster/upload/truststore',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function getChannels () {
  return request ({
    url: '/api/v1/cluster/endpoints',
    method: 'get'
  })
}

export function getActiveChannels () {
  return request ({
    url: '/api/v1/cluster/active/endpoints',
    method: 'get'
  })
}

export function getActiveGroups (broadcast, dcName) {
  return request ({
    url: '/api/v1/cluster/groups',
    method: 'get',
    params: {
      broadcast, dcName
    }
  })
}

export function getTaskGroups (topicId) {
  return request ({
    url: '/api/v1/task/groups',
    method: 'get',
    params: {
      topicId
    }
  })
}

export function getTaskSubtopics (topicId) {
  return request ({
    url: '/api/v1/task/subtopics',
    method: 'get',
    params: {
      topicId
    }
  })
}

export function getChannelById (id) {
  return request ({
    url: '/api/v1/cluster/endpoint/' + id,
    method: 'get'
  })
}

export function listChannelWithCredential () {
  return request ({
    url: '/api/v1/cluster/endpoints_with_credential',
    method: 'get'
  })
}

export function createChannel (data) {
  return request ({
    url: '/api/v1/cluster',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function activeDC (name, active) {
  return request ({
    url: '/api/v1/dc/' + name + '/status',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      active
    }
  })
}

export function activeChannel (id, active) {
  return request ({
    url: '/api/v1/cluster/' + id + '/status',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      id,
      active
    }
  })
}

export function resetChannel (id, data) {
  return request ({
    url: '/api/v1/cluster/' + id + '/reset',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function updateChannel (id, data) {
  return request ({
    url: '/api/v1/cluster/' + id + '/edit',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function refreshChannel (id) {
  return request ({
    url: '/api/v1/cluster/' + id + '/refresh',
    method: 'post'
  })
}

export function getPubsub (from, to) {
  return request ({
    url: '/api/v1/count/pubsub',
    method: 'get',
    params: {
      from,
      to
    }
  })
}

export function getTopicCount (topicId, from, to) {
  return request ({
    url: '/api/v1/count/topic',
    method: 'get',
    params: {
      topicId,
      from,
      to
    }
  })
}

export function getUserCount (userId, from, to) {
  return request ({
    url: '/api/v1/count/user',
    method: 'get',
    params: {
      userId,
      from,
      to
    }
  })
}

export function getMqType () {
  return request ({
    url: '/api/v1/cluster/mq/type',
    method: 'get'
  })
}

export function getTopics () {
  return request ({
    url: '/api/v1/topic/external',
    method: 'get'
  })
}

export function getUsers () {
  return request ({
    url: '/api/v1/user/all/exclude/readonly',
    method: 'get'
  })
}

export function deleteSsl (id) {
  return request ({
    url: '/api/v1/cluster/ssl/' + id,
    method: 'delete'
  })
}

export function getAuditLog (className, methodName, param, operator, from, to, size, page) {
  return request ({
    url: '/api/v1/auditlog/search',
    method: 'get',
    params: {
      className, methodName, param, operator, from, to, size, page
    }
  })
}

export function deleteLogs (className, methodName, param, operator, from, to) {
  return request ({
    url: '/api/v1/auditlog/delete',
    method: 'get',
    params: {
      className, methodName, param, operator, from, to
    }
  })
}

export function getTopicAlert (alertStatus, alertType, alertUserId, topicName, from, to, size, page) {
  return request ({
    url: '/api/v1/topicalert/search',
    method: 'get',
    params: {
      alertStatus, alertType, alertUserId, topicName, from, to, size, page
    }
  })
}

export function deleteTopicAlerts (alertStatus, alertType, alertUserId, topicName, from, to) {
  return request ({
    url: '/api/v1/topicalert/delete',
    method: 'get',
    params: {
      alertStatus, alertType, alertUserId, topicName, from, to
    }
  })
}

export function deleteChannel (id) {
  return request ({
    url: '/api/v1/cluster/' + id,
    method: 'delete'
  })
}

export function batchSetSubscribers (data) {
  return request ({
    url: '/api/v1/topic/subscriber/batch/setting',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function updateSubscriptionIpVerify (data) {
  return request ({
    url: '/api/v1/topic/subscription/verify/setting',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}
export function updateSubscriptionIpListByClick (data) {
  return request ({
    url: '/api/v1/topic/subscription/ip_list/setting',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}
export function batchSetPublishers (data) {
  return request ({
    url: '/api/v1/topic/producer/batch/setting',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}
export function setThreshold (data) {
  return request ({
    url: '/api/v1/topic/update/subscriber',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function getDc (listUnReadyDc, containNodes) {
  return request ({
    url: '/api/v1/dc_list',
    method: 'get',
    params: {
      listUnReadyDc,
      containNodes
    }
  })
}

export function updateBackup (name, data) {
  return request ({
    url: '/api/v1/dc/' + name,
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function updateDc (data) {
  return request ({
    url: '/api/v1/dc',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function deleteDC (name) {
  return request ({
    url: '/api/v1/dc/' + name,
    method: 'delete'
  })
}

export function batchDeleteSub (ids) {
  return request ({
    url: '/api/v1/topic/subscriber/batch/delete',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      ids
    }
  })
}

export function batchDeletePub (ids) {
  return request ({
    url: '/api/v1/topic/producer/batch/delete',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      ids
    }
  })
}

export function dropTopic (id) {
  return request ({
    url: '/api/v1/topic/' + id + '/drop',
    method: 'delete'
  })
}

export function getLeo (id) {
  return request ({
    url: '/api/v1/topic/' + id + '/leo',
    method: 'get'
  })
}

export function getHAInfo (id) {
  return request ({
    url: '/api/v1/topic/' + id + '/hainfo',
    method: 'get'
  })
}

export function getZK () {
  return request ({
    url: '/api/v1/cluster/zk',
    method: 'get'
  })
}

export function getGlobalZK () {
  return request ({
    url: '/api/v1/cluster/globalZk',
    method: 'get'
  })
}

export function getChannelListForMigration (id) {
  return request ({
    url: '/api/v1/topic/' + id + '/listMigratableTopics',
    method: 'get'
  })
}

export function getMigrationInfo (id) {
  return request ({
    url: '/api/v1/topic/' + id + '/migrateInfo',
    method: 'get'
  })
}

export function migrateTopics (data) {
  return request ({
    url: '/api/v1/topic/migrate',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function getChannelDcs () {
  return request ({
    url: '/api/v1/cluster/dc/list',
    method: 'get'
  })
}

export function createChannelDc (data) {
  return request ({
    url: '/api/v1/cluster/dc/add',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function deleteChannelDc (id) {
  return request ({
    url: '/api/v1/cluster/dc/delete/' + id,
    method: 'delete'
  })
}

export function getChannelTopics (id) {
  return request ({
    url: '/api/v1/command/list/topics/' + id,
    method: 'get'
  })
}

export function getChannelGroups (id) {
  return request ({
    url: '/api/v1/command/list/groups/' + id,
    method: 'get'
  })
}

export function getTopicDescribe (id, topicUrl) {
  return request ({
    url: '/api/v1/command/describe/topic/' + id + '/' + topicUrl,
    method: 'get'
  })
}

export function getGroupDescribe (id, groupId) {
  return request ({
    url: '/api/v1/command/describe/group/' + id + '/' + groupId,
    method: 'get'
  })
}

export function recoveryChannel (id) {
  return request ({
    url: '/api/v1/cluster/' + id + '/recovery',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function expandChannel (data) {
  return request ({
    url: '/api/v1/cluster/expand',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function verifyChannel (data) {
  return request ({
    url: '/api/v1/cluster/verify',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getTopicMap (id) {
  return request ({
    url: '/api/v1/map/topic/' + id,
    method: 'get'
  })
}

export function getUserMap (id) {
  return request ({
    url: '/api/v1/map/user/' + id,
    method: 'get'
  })
}

export function getMapMetrics (userId, topicId) {
  return request ({
    url: '/api/v1/map/metrics',
    method: 'get',
    params: {
      userId, topicId
    }
  })
}

export function getTopicLogdir (params) {
  return request ({
    url: '/api/v1/topic/logdir',
    method: 'get',
    params
  })
}

export function getMetrics (data) {
  return request ({
    url: '/api/v1/monitor/metrics',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getMetricsNameList () {
  return request ({
    url: '/api/v1/monitor',
    method: 'get'
  })
}

export function getLabelList () {
  return request ({
    url: '/api/v1/monitor/list/labels',
    method: 'get'
  })
}

export function alterRp (data) {
  return request ({
    url: '/api/v1/monitor/alter/rp',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function resetTopicRemain (data) {
  return request ({
    url: '/api/v1/topic/remain/reset',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function resetTopicRemainV2 (data) {
  return request ({
    url: '/api/v1/topic/remain/reset/v2',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function resetTopicRemainV3 (data) {
  return request ({
    url: '/api/v1/topic/remain/reset/v3',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getMQClusterStatus () {
  return request ({
    url: '/api/v1/cluster/status',
    method: 'get'
  })
}

export function getTopicTask (params) {
  return request ({
    url: '/api/v1/task/query',
    method: 'get',
    params
  })
}

export function getSubscriberMaps (sdkVersion) {
  return request ({
    url: '/api/v1/topic/query/subscriber/old_version',
    method: 'get',
    params: {
      sdkVersion
    }
  })
}

export function createSubscriber (data) {
  return request ({
    url: '/api/v1/topic/create/subscriber',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export function downloadSubcribers(id){
  return request({
    url:'/api/v1/topic/'+id+'/subscribers/download',
    method:'get',
    responseType:'blob'
  })
}

export function downloadProducers(id) {
  return request({
    url: '/api/v1/topic/' + id + '/producers/download',
    method: 'get',
    responseType: 'blob'
  })
}

export function downloadTopics() {
  return request({
    url: '/api/v1/topic/information/download',
    method: 'get',
    responseType: 'blob'
  })
}

export function downloadUsers() {
  return request({
    url: '/api/v1/user/information/download',
    method: 'get',
    responseType: 'blob'
  })
}

export function metricsQuery (data) {
  return request ({
    url: '/api/v1/monitor/general/metricsQuery',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function metricsRank (data) {
  return request ({
    url: '/api/v1/monitor/general/metricsRank',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
